import { render, staticRenderFns } from "./RawMaterialComponent.vue?vue&type=template&id=f8f0503c&scoped=true&"
import script from "./RawMaterialComponent.vue?vue&type=script&lang=js&"
export * from "./RawMaterialComponent.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterialComponent.vue?vue&type=style&index=0&id=f8f0503c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f0503c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VProgressLinear})
